module.exports = __webpack_public_path__ + "img/link.5656559.png";